
<div>
    <app-bar :title="t('external_contents_title')"></app-bar>

    <v-layout>
        <external-content-collection></external-content-collection>
    </v-layout>
</div>
